<div class="header-label">Lookup Tables</div>
<div class="flex-fill d-flex flex-column dx-card responsive-paddings">
  <div class="d-flex flex-row">
    <div class="m-1">
      <div class="d-flex align-items-center m-1">
        <label class="me-2" style="text-align: end; min-width: 130px">Fuel Rate</label>
        <dx-number-box class="me-2" style="max-width: 175px" [(value)]="fuelRate"></dx-number-box>
        <button class="btn btn-danger" (click)="setSetting('FuelRate', fuelRate, 'decimal')">Set</button>
      </div>
      <div class="d-flex align-items-center m-1">
        <label class="me-2" style="text-align: end; min-width: 130px">Fuel Percentage</label>
        <dx-number-box class="me-2" style="max-width: 175px" [(value)]="fuelPercentage"></dx-number-box>
        <button class="btn btn-danger me-2" (click)="setFuelPercentage()">Set</button>
        @if (activeFuelRatePercentage) {
          <label class="me-2" style="text-align: end; min-width: 130px">
            Last Updated: {{ activeFuelRatePercentage.startDate | date }}
          </label>
        }
      </div>
      <div class="d-flex align-items-center m-1">
        <label class="me-2" style="text-align: end; min-width: 130px">Overage Rate</label>
        <dx-number-box class="me-2" style="max-width: 175px" [(value)]="overageRate"></dx-number-box>
        <button class="btn btn-danger" (click)="setSetting('OverageRate', overageRate, 'decimal')">Set</button>
      </div>
      <div class="d-flex align-items-center m-1">
        <label class="me-2" style="text-align: end; min-width: 130px">Extended Overage Rate</label>
        <dx-number-box class="me-2" style="max-width: 175px" [(value)]="extendedOverageRate"></dx-number-box>
        <button class="btn btn-danger" (click)="setSetting('ExtendedOverageRate', extendedOverageRate, 'decimal')">Set</button>
      </div>
      <div class="d-flex align-items-center m-1">
        <label class="me-2" style="text-align: end; min-width: 130px">Outer Overage Rate</label>
        <dx-number-box class="me-2" style="max-width: 175px" [(value)]="outerOverageRate"></dx-number-box>
        <button class="btn btn-danger" (click)="setSetting('OuterOverageRate', outerOverageRate, 'decimal')">Set</button>
      </div>
      <div class="d-flex align-items-center m-1">
        <label class="me-2" style="text-align: end; min-width: 130px">Kalamazoo Overage Rate</label>
        <dx-number-box class="me-2" style="max-width: 175px" [(value)]="kalamazooOverageRate"></dx-number-box>
        <button class="btn btn-danger" (click)="setSetting('KalamazooOverageRate', kalamazooOverageRate, 'decimal')">Set</button>
      </div>
      <div class="d-flex align-items-center m-1">
        <label class="me-2" style="text-align: end; min-width: 130px">Service Rate</label>
        <dx-number-box class="me-2" style="max-width: 175px" [(value)]="serviceRate"></dx-number-box>
        <button class="btn btn-danger" (click)="setSetting('ServiceRate', serviceRate, 'decimal')">Set</button>
      </div>
      <div class="d-flex align-items-center m-1">
        <label class="me-2" style="text-align: end; min-width: 130px">Extension Rate (per day)</label>
        <dx-number-box class="me-2" style="max-width: 175px" [(value)]="extensionRate"></dx-number-box>
        <button class="btn btn-danger" (click)="setSetting('ExtensionRate', extensionRate, 'decimal')">Set</button>
      </div>
      <div class="d-flex align-items-center m-1">
        <label class="me-2" style="text-align: end; min-width: 130px">Average Job Expense</label>
        <dx-number-box class="me-2" style="max-width: 175px" [(value)]="averageExpensePerJob"></dx-number-box>
        <button class="btn btn-danger" (click)="setSetting('AverageExpensePerJob', averageExpensePerJob, 'decimal')">Set</button>
      </div>
      <div class="d-flex align-items-center m-1">
        <label class="me-2" style="text-align: end; min-width: 130px">Average Hour Expense</label>
        <dx-number-box class="me-2" style="max-width: 175px" [(value)]="averageHourExpense"></dx-number-box>
        <button class="btn btn-danger" (click)="setSetting('AverageHourExpense', averageHourExpense, 'decimal')">Set</button>
      </div>
    </div>
    <div class="flex-fill m-1" style="max-width: 600px">
      <div class="d-flex flex-fill align-items-baseline m-1">
        <label class="me-2" style="text-align: end; min-width: 120px">Invoice Email Subject</label>
        <dx-text-box class="me-2 flex-fill" [(value)]="emailSubject"></dx-text-box>
        <button class="btn btn-danger" (click)="setSetting('EmailSubject', emailSubject)">Set</button>
      </div>
      <div class="d-flex flex-fill align-items-baseline m-1">
        <label class="me-2" style="text-align: end; min-width: 120px">Invoice Email Body</label>
        <dx-text-area class="me-2 flex-fill" height="100px" [(value)]="emailBody"></dx-text-area>
        <button class="btn btn-danger" (click)="setSetting('EmailBody', emailBody)">Set</button>
      </div>
      <div class="d-flex flex-fill align-items-baseline m-1">
        <label class="me-2" style="text-align: end; min-width: 130px">Invoice Report Footer</label>
        <dx-text-area class="me-2 flex-fill" height="100px" [(value)]="invoiceFooter"></dx-text-area>
        <button class="btn btn-danger" (click)="setSetting('InvoiceFooter', invoiceFooter)">Set</button>
      </div>
      <div class="d-flex flex-fill align-items-baseline m-1">
        <label class="me-2" style="text-align: end; min-width: 130px">Open Invoice Email Subject</label>
        <dx-text-box class="me-2 flex-fill" [(value)]="openInvoiceEmailSubject"></dx-text-box>
        <button class="btn btn-danger" (click)="setSetting('OpenInvoiceEmailSubject', openInvoiceEmailSubject)">Set</button>
      </div>
      <div class="d-flex flex-fill align-items-baseline m-1">
        <label class="me-2" style="text-align: end; min-width: 130px">Open Invoice Email Body</label>
        <dx-text-area class="me-2 flex-fill" height="100px" [(value)]="openInvoiceEmailBody"></dx-text-area>
        <button class="btn btn-danger" (click)="setSetting('OpenInvoiceEmailBody', openInvoiceEmailBody)">Set</button>
      </div>
    </div>
    <div class="flex-fill m-1" style="max-width: 600px">
      <div class="d-flex flex-fill align-items-baseline m-1">
        <label class="me-2" style="text-align: end; min-width: 120px">Payment Email Subject</label>
        <dx-text-box class="me-2 flex-fill" [(value)]="paymentEmailSubject"></dx-text-box>
        <button class="btn btn-danger" (click)="setSetting('PaymentEmailSubject', paymentEmailSubject)">Set</button>
      </div>
      <div class="d-flex flex-fill align-items-baseline m-1">
        <label class="me-2" style="text-align: end; min-width: 120px">Payment Email Body</label>
        <dx-text-area class="me-2 flex-fill" height="100px" [(value)]="paymentEmailBody"></dx-text-area>
        <button class="btn btn-danger" (click)="setSetting('PaymentEmailBody', paymentEmailBody)">Set</button>
      </div>
    </div>
    <div class="flex-fill m-1" style="max-width: 600px">
      <div class="d-flex flex-fill align-items-baseline m-1">
        <label class="me-2" style="text-align: end; min-width: 130px">Statement Email Subject</label>
        <dx-text-box class="me-2 flex-fill" [(value)]="statementEmailSubject"></dx-text-box>
        <button class="btn btn-danger" (click)="setSetting('StatementEmailSubject', statementEmailSubject)">Set</button>
      </div>
      <div class="d-flex flex-fill align-items-baseline m-1">
        <label class="me-2" style="text-align: end; min-width: 130px">Statement Email Body</label>
        <dx-text-area class="me-2 flex-fill" height="100px" [(value)]="statementEmailBody"></dx-text-area>
        <button class="btn btn-danger" (click)="setSetting('StatementEmailBody', statementEmailBody)">Set</button>
      </div>
    </div>
  </div>

  @if (filter) {
    <dx-form class="d-flex my-2" [formData]="filter">
      @if (filter) {
        <dxi-form-item [label]="{ text: 'Table' }">
          <div *dxTemplate>
            <dx-select-box
              [(value)]="filter.table"
              [items]="tables"
              [searchEnabled]="true"
              (onValueChanged)="selectionChanged($event)"
            ></dx-select-box>
          </div>
        </dxi-form-item>
      }
    </dx-form>
  }

  @if (entities) {
    <div class="d-flex flex-fill flex-column">
      <dx-data-grid
        #dataGrid
        keyExpr="id"
        class="d-flex flex-fill flex-column"
        height="100px"
        [dataSource]="entities"
        [showBorders]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onRowDblClick)="rowDoubleClick($event)"
        >
        @if (filter.table === 'County Rates') {
          <dxi-data-grid-column dataField="name" caption="County" width="350"></dxi-data-grid-column>
        }
        @if (filter.table === 'County Rates') {
          <dxi-data-grid-column
            dataField="rate"
            [format]="{ type: 'currency', precision: 2 }"
            width="150"
          ></dxi-data-grid-column>
        }
        @if (filter.table === 'Credit Cards') {
          <dxi-data-grid-column dataField="name" width="350"></dxi-data-grid-column>
        }
        @if (filter.table === 'Credit Cards') {
          <dxi-data-grid-column dataField="feePercentage" width="150"></dxi-data-grid-column>
        }
        @if (filter.table === 'Dumpsters') {
          <dxi-data-grid-column dataField="size" width="350"></dxi-data-grid-column>
        }
        @if (filter.table === 'Dumpsters') {
          <dxi-data-grid-column
            dataField="basePrice"
            [format]="{ type: 'currency', precision: 2 }"
            width="150"
          ></dxi-data-grid-column>
        }
        @if (filter.table === 'Dumpsters') {
          <dxi-data-grid-column
            dataField="extendedPrice"
            [format]="{ type: 'currency', precision: 2 }"
            width="150"
          ></dxi-data-grid-column>
        }
        @if (filter.table === 'Dumpsters') {
          <dxi-data-grid-column
            dataField="outerPrice"
            [format]="{ type: 'currency', precision: 2 }"
            width="150"
          ></dxi-data-grid-column>
        }
        @if (filter.table === 'Dumpsters') {
          <dxi-data-grid-column
            dataField="kalamazooPrice"
            [format]="{ type: 'currency', precision: 2 }"
            width="150"
          ></dxi-data-grid-column>
        }
        @if (filter.table === 'Dumpsters') {
          <dxi-data-grid-column
            dataField="weightLimit"
            [format]="{ type: 'fixedPoint', precision: 2 }"
            width="150"
          ></dxi-data-grid-column>
        }
        @if (filter.table === 'Dumpsters') {
          <dxi-data-grid-column dataField="category.name" caption="Category" width="175"></dxi-data-grid-column>
        }
        @if (filter.table === 'Dumpsters') {
          <dxi-data-grid-column dataField="trackInventory" width="150"></dxi-data-grid-column>
        }
        @if (filter.table === 'Dumpsters') {
          <dxi-data-grid-column dataField="chargeKentFee" width="150"></dxi-data-grid-column>
        }
        @if (filter.table === 'Dumpsters') {
          <dxi-data-grid-column dataField="chargeMichiganFee" width="150"></dxi-data-grid-column>
        }
        @if (filter.table === 'Dumpsters') {
          <dxi-data-grid-column dataField="includeTonExpense" width="150"></dxi-data-grid-column>
        }
        @if (filter.table === 'Dumpster Categories' || filter.table === 'Sales People') {
          <dxi-data-grid-column dataField="name" width="350"></dxi-data-grid-column>
        }
        @if (filter.table === 'Dumpster Fee Types') {
          <dxi-data-grid-column dataField="name" width="150"></dxi-data-grid-column>
        }
        @if (filter.table === 'Dumpster Fee Types') {
          <dxi-data-grid-column
            dataField="price"
            [format]="{ type: 'currency', precision: 2 }"
            width="150"
          ></dxi-data-grid-column>
        }
        @if (filter.table === 'Dumpster Fee Types') {
          <dxi-data-grid-column dataField="visibleForPickup" width="150"></dxi-data-grid-column>
        }
        @if (filter.table === 'Dumpster Fee Types') {
          <dxi-data-grid-column dataField="visibleForDropOff" width="150"></dxi-data-grid-column>
        }
        @if (filter.table === 'Dumpster Fee Types') {
          <dxi-data-grid-column
            dataField="displayLinks"
            caption="Associated Dumpsters"
            width="350"
          ></dxi-data-grid-column>
        }
        @if (filter.table === 'QuickBooks Products') {
          <dxi-data-grid-column dataField="quickBooksProductService" width="250"></dxi-data-grid-column>
        }
        @if (filter.table === 'QuickBooks Products') {
          <dxi-data-grid-column dataField="quickBooksAccount" width="150"></dxi-data-grid-column>
        }
        @if (filter.table === 'QuickBooks Products') {
          <dxi-data-grid-column dataField="quickBooksId" width="125"></dxi-data-grid-column>
        }
        @if (filter.table === 'QuickBooks Products') {
          <dxi-data-grid-column
            dataField="quickBooksLastSync"
            format="shortDateShortTime"
            width="175"
          ></dxi-data-grid-column>
        }
        @if (filter.table === 'QuickBooks Products') {
          <dxi-data-grid-column dataField="azureType" caption="Type" width="150"></dxi-data-grid-column>
        }
        @if (filter.table === 'QuickBooks Products') {
          <dxi-data-grid-column dataField="isVisible" caption="Visible" width="100"></dxi-data-grid-column>
        }
        @if (filter.table === 'QuickBooks Products') {
          <dxi-data-grid-column
            dataField="sETBillingCode"
            caption="SET Code"
            width="100"
          ></dxi-data-grid-column>
        }
        @if (filter.table === 'Time Types') {
          <dxi-data-grid-column dataField="name" width="350"></dxi-data-grid-column>
        }
        @if (filter.table === 'Time Types') {
          <dxi-data-grid-column dataField="pTO" width="150"></dxi-data-grid-column>
        }
        @if (filter.table === 'Ton Expenses') {
          <dxi-data-grid-column dataField="name" width="350"></dxi-data-grid-column>
        }
        @if (filter.table === 'Ton Expenses') {
          <dxi-data-grid-column dataField="amount" width="150"></dxi-data-grid-column>
        }
        <dxi-data-grid-column></dxi-data-grid-column>
        <div *dxTemplate="let data of 'toolbarButtons'">
          <button
            [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
            (click)="openSelection(dataGrid.instance.getSelectedRowsData()[0])"
            class="btn btn-primary ms-2"
            >
            {{ filter.table === 'QuickBooks Products' ? 'Edit SET Code' : 'Edit' }}
          </button>
          <button
            [hidden]="filter.table !== 'QuickBooks Products'"
            [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
            (click)="toggleVisibility(dataGrid.instance.getSelectedRowsData())"
            class="btn btn-primary ms-2"
            >
            Toggle Visibility
          </button>
          <button [hidden]="filter.table === 'QuickBooks Products'" (click)="openSelection()" class="btn btn-success ms-1">
            Add
          </button>
          <button
            [hidden]="filter.table === 'Dumpsters' || filter.table === 'QuickBooks Products'"
            [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
            (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
            class="ms-2 btn btn-danger"
            >
            Delete
          </button>
        </div>
        <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
        <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
        <dxo-data-grid-row-dragging
          [allowReordering]="filter.table !== 'Dumpsters'"
          [onReorder]="onReorder"
          [showDragIcons]="false"
        ></dxo-data-grid-row-dragging>
      </dx-data-grid>
    </div>
  }
</div>
